export default "__VITE_ASSET__LxI6dRq7__"